import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { FLAVORS } from "@/lib/catalog";

export default function RecipeShowcase() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-40px", "40px"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["30px", "-30px"]);
  const y3 = useTransform(scrollYProgress, [0, 1], ["-20px", "20px"]);

  const parallax = [y1, y2, y3, y2, y1];

  return (
    <section ref={ref} data-testid="recipe-showcase" className="border-y border-black bg-white overflow-hidden">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em]">
              <span className="inline-block w-10 h-px bg-black" />
              <span>5 recheios · 1 massa</span>
            </div>
            <h2 className="font-display mt-6 text-4xl sm:text-6xl md:text-7xl leading-[0.95] tracking-[-0.025em]">
              Uma base.<br />Mil versões.
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 text-base md:text-lg leading-relaxed">
            O mesmo brownie denso, úmido, de cacau 100%. Troque só o recheio e você
            muda a história: doce de leite, pistache, beijinho de coco, cookies & cream
            — ou o seu. Faça você mesmo, do seu jeito.
          </p>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
          {FLAVORS.map((f, i) => (
            <motion.figure
              key={f.slug}
              style={{ y: parallax[i % parallax.length] }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: i * 0.08 }}
              className="relative aspect-[4/5] border border-black overflow-hidden bg-white"
            >
              <img
                src={f.img}
                alt={f.label}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-[1.04]"
                loading="lazy"
              />
              <figcaption className="absolute left-2 bottom-2 bg-white border border-black px-2 py-1 text-[10px] md:text-xs uppercase tracking-[0.18em]">
                {f.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
